import { collarProductIsSupportedInCountry, useLocale } from '../contexts/LocaleContext';
import { inPartnerPromoContext } from '../lib/hardwareFirstPartnerContext';
import * as types from '../types';
import { showNanoVariant } from '../components/NanoBanner/NanoBanner';
import { showRescueGwaVariant } from '../views/RescueLanding/RescueBanner';

/**
 * Whether this visitor gets the pick-your-fi shop at `/shop`. Partner, rescue and nano contexts keep
 * the classic listing at `/products`: partner promos must not mix with the new pricing model. A
 * referred visitor gets the shop like anyone else; the referral code stays on the cart so the referrer
 * is still credited at purchase. The in-app shop follows the same rules as the web. Mini is the entry
 * tracker, so a market that cannot sell it has no page to show.
 */
export default function useHardwareFirstShop(): boolean {
  const { country } = useLocale();

  return (
    !inPartnerPromoContext() &&
    !showRescueGwaVariant() &&
    !showNanoVariant() &&
    collarProductIsSupportedInCountry(types.miniCollarId, country)
  );
}
